const apply = () => {
  // セレクトボックス
  const checkListSelect = <HTMLInputElement>document.getElementById("inspection_check_list_id");
  // 全て問題なしボタン
  const allCheckBtn = document.getElementById("all-check-btn");
  // チェックリスト
  const items = document.getElementById("inspection-items");

  if (!(checkListSelect && allCheckBtn && items)) return;

  // チェックリストの表示切り替え
  const selectedHandler = () => {
    location.href = `${location.origin}${location.pathname}?check_list_id=${checkListSelect.value}`;
  };

  // 全て問題なしボタンのクリックイベント
  const onClickHandler = () => {
    const checkBoxes = items.getElementsByTagName("input");

    Array.from(checkBoxes).forEach((cb) => {
      cb.checked = true;
    });
  };

  checkListSelect.addEventListener("change", selectedHandler);
  allCheckBtn.addEventListener("click", onClickHandler);
};

const initialInspection = () => {
  ["turbo:load", "turbo:render"].forEach((event) => {
    document.addEventListener(event, apply);
  });
};

export default initialInspection;
